export default __webpack_public_path__ + "static/03d70b44-c412-472f-a02f-6af1a09f3ca2-db3f233cafd25857f88b43e36ffb614a.jpg";